export const analytics = (partnersIds) => {
  window.dataLayer = window.dataLayer || []
  function gtag() {
    dataLayer.push(arguments)
  }
  gtag('js', new Date())

  Object.entries(partnersIds).forEach(([partnerId, partnerOptions]) => {
    gtag('config', partnerId)

    if ('events' in partnerOptions) {
      callEvents(partnerId, partnerOptions.data, partnerOptions.events)
    }
  })

  function callEvents(partnerId, partnerData, tracks) {
    Object.entries(tracks).forEach(([index, track]) => {
      if (track.type == 'checkout') {
        callCheckoutEvent()
        return
      }

      if (track.type == 'purchase') {
        callConversionEvent(partnerId, partnerData, track.params)
      }
    })
  }

  function callCheckoutEvent() {
    gtag('event', 'begin_checkout')
  }

  function callConversionEvent(partnerId, partnerData, params) {
    gtag('event', 'purchase', {
      send_to: partnerId,
      event_category: params.eventCategory,
      event_label: params.eventLabel,
      value: params.value,
    })
  }
}
